

































import { Vue, Component, Prop } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Friend extends Vue {
  dialog = false;
  seluser = {};
  mounted() {
    this.$store.dispatch("bindRecived");
    this.$store.dispatch("bindChatRoom");
  }
  defaultChatRoom = Object.freeze({
    participants: [] as any,
    messages: [] as any,
  });
  // eslint-disable-next-line
  cancelReq(user: any) {
    this.$store.dispatch("removeFromRequests", {
      collection: "users",
      doc: this.currentUser.uid,
      sendRequests: "sendRequests",
      recivedRequests: "RecivedRequests",
      payload: user.uid,
    });
  }
  chatRoom = { ...this.defaultChatRoom };
  accecpt(user: any) {
    this.$store.dispatch("acceptRequests", {
      collection: "users",
      doc: {
        uid: this.currentUser.uid,
      },
      acceptRequests: "friends",
      payload: {
        uid: user.uid,
      },
    });
    this.$store.dispatch("removeFromRequests", {
      collection: "users",
      doc: this.currentUser.uid,
      sendRequests: "sendRequests",
      recivedRequests: "RecivedRequests",
      payload: user.uid,
    });
    this.chatRoom.participants.push({
      name: this.currentUser.userName,
      profilePicture: this.currentUser.photoURL,
      id: this.currentUser.uid,
    });
    this.chatRoom.participants.push({
      name: this.getUserName(user.uid),
      profilePicture: this.getPhotoUrl(user.uid),
      id: user.uid,
    });
    this.$store.dispatch("createChatRoom", {
      collection: "chatRooms",
      payload: this.chatRoom,
    });
  }
  showUserProfile(id: any) {
    this.$router.push(`/userProfile/${id}`);
  }
  get reciveds() {
    return this.$store.state.reciveds;
  }
  getPhotoUrl(uid: any) {
    if (this.$store.state.recivedUsers.find((user: any) => user.uid === uid)) {
      return this.$store.state.recivedUsers.find(
        (user: any) => user.uid === uid
      ).photoURL;
    }
    return "dp";
  }
  getUserName(uid: any) {
    if (this.$store.state.recivedUsers.find((user: any) => user.uid === uid)) {
      const userObj = this.$store.state.recivedUsers.find(
        (user: any) => user.uid === uid
      );
      return userObj.userName;
    }
    return null;
  }
  get currentUser() {
    return this.$store.state.currentUser;
  }
}
